import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDynamicDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class Fm extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getDynamicDataList('35-', 11);

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { fmMd, fmSlide, fmRecommendFeed, fmAd, isAsync } = content;

        const normalTabsData = fmMd;
        const viewMoreLinkData = (fmMd && fmMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : fmRecommendFeed;
        const mdBannerData = fmSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50159',
                type: 'struct',
                title: '知之有声子导航数据',
                groupName: 'content',
                translate: 'handleHomeFmMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '75187',
                type: 'recommend',
                title: '知之有声焦点图数据',
                groupName: 'content',
                translate: 'handleHomeFmSlideInfo',
            };
        }
        const newsStreamChipConfig = {
            id: '75305',
            type: 'recommend',
            title: '知之有声信息流推荐数据',
            groupName: 'content',
            translate: 'handleHomeFmRecommendFeedInfo',
        };

        const moduleData = {
            normalTabsData,
            newsStreamChipConfig,
            feedAd: fmAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.fm}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(Fm);
